import { atom, useAtom } from 'jotai';

const showEditDeliveryExitWarningDialog = atom<{ show: boolean; nextRoute?: string | number }>({
  show: false,
});

export const useShowEditDeliveryExitWarningDialog = () => useAtom(showEditDeliveryExitWarningDialog);
